import { useRef } from 'react';
import * as colors from './colors';

function createUniqueId(label) {
  var uniqueId = "".concat(label, "-").concat(Math.floor(Math.random() * 0xffff));
  return uniqueId.replace(/[^A-Za-z0-9-]/gi, '');
} // eslint-disable-next-line import/prefer-default-export


export var mapBsStyleToColor = function mapBsStyleToColor(bsStyle) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$shade = _ref.shade,
      shade = _ref$shade === void 0 ? 'base' : _ref$shade,
      _ref$fallback = _ref.fallback,
      fallback = _ref$fallback === void 0 ? colors.coal : _ref$fallback;

  var result = colors[bsStyle];

  if (result && result[shade]) {
    result = result[shade];
  } else {
    result = fallback;
  }

  return result;
};
export var useCreateInputId = function useCreateInputId(id, label) {
  var inputRef = useRef(null);

  if (inputRef.current === null) {
    inputRef.current = id || createUniqueId(label);
  }

  return inputRef.current;
};